import React, { useState } from 'react'
import { LoaderBar, PageHeader } from 'components'
import { CustomFieldList, CustomFieldAddEditModal } from 'page-components/custom-field'
import { DesktopMode, MobileMode } from 'layout'
import { AppPrimaryButton } from 'elements'

export const CustomFieldManagerScreen = () => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [modalData, setModalData] = useState({})
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: 10,
    })
    const [totalCount, setTotalCount] = useState(0)

    React.useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            try {
                setData([])
                setTotalCount(0)
            } catch (error) {
                console.error('Error fetching custom fields:', error)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [])

    const pageChanged = (newFilter) => {
        setFilter(newFilter)
    }

    const handleAddField = () => {
        return null
    }

    const handleEdit = (item) => {
        return item
    }

    const handleRemove = async (id) => {
        return id
    }

    const handleClose = async (formData) => {
        if (formData) return
        setModalData({})
    }

    return (
        <>
            {/* Desktop Layout */}
            <DesktopMode>
                <div className="row mb-3">
                    <div className="col-8">
                        <PageHeader header="Custom Field Manager" />
                    </div>
                    <div className="col-4">
                        <div style={{ marginTop: '8px' }}>
                            <AppPrimaryButton
                                type="button"
                                onClick={handleAddField}
                                fluid
                                disabled
                            >
                                Add Field
                            </AppPrimaryButton>
                        </div>
                    </div>
                </div>
            </DesktopMode>

            {/* Mobile Layout */}
            <MobileMode>
                <div className="row mb-3">
                    <div className="col-12">
                        <PageHeader header="Custom Field Manager" />
                    </div>
                    <div className="col-12 mt-2">
                        <AppPrimaryButton
                            type="button"
                            onClick={handleAddField}
                            fluid
                            disabled
                        >
                            Add Field
                        </AppPrimaryButton>
                    </div>
                </div>
            </MobileMode>

            <div className="col-12">
                <CustomFieldAddEditModal open={false} onClose={handleClose} data={modalData} loading="" />
            </div>

            <div className="my-3">
                {loading && <LoaderBar content="Loading" />}
                {!loading && (
                    <div style={{ color: '#666', marginBottom: '16px' }}>
                        Custom Field Manager is hidden until backend custom-field
                        APIs are available.
                    </div>
                )}
                {!loading && (
                    <CustomFieldList
                        data={data}
                        filter={filter}
                        pageChanged={pageChanged}
                        totalCount={totalCount}
                        onEdit={handleEdit}
                        onRemove={handleRemove}
                    />
                )}
            </div>
        </>
    )
}
